import { formatFiatUnits } from '../amount/format-money.js';
export const paymentMethodTranslationKeys = [
    'onramp.profile_limits_loading',
    'onramp.profile_method_limits_failed',
    'onramp.profile_method_daily_limit',
    'onramp.profile_method_monthly_limit',
    'onramp.profile_method_yearly_limit',
    'onramp.profile_method_card_limits',
    'onramp.profile_method_no_allowance',
    'onramp.profile_method_minimum',
    'onramp.profile_method_maximum',
];
export function paymentMethodPills(options) {
    const { allowance, translate: t } = options;
    const pills = [];
    if (options.bounded) {
        if (options.loading)
            pills.push({ text: t('profile_limits_loading'), tone: 'neutral' });
        else if (options.error || allowance === null)
            pills.push({ text: t('profile_method_limits_failed'), tone: 'destructive' });
        else if (allowance?.limits.length) {
            for (const limit of allowance.limits) {
                pills.push({
                    tone: limit.period === 'daily'
                        ? 'info'
                        : limit.period === 'monthly'
                            ? 'brand'
                            : 'success-subtle',
                    text: t(`profile_method_${limit.period}_limit`, {
                        remaining: formatWholeFiat(limit.remainingUnits, allowance.decimals, allowance.currency, options.locale),
                        total: formatWholeFiat(limit.limitUnits, allowance.decimals, allowance.currency, options.locale),
                    }),
                });
            }
        }
        else
            pills.push({
                tone: 'neutral',
                text: t(allowance?.evidence === 'card_required'
                    ? 'profile_method_card_limits'
                    : 'profile_method_no_allowance'),
            });
        for (const [key, units] of [
            ['profile_method_minimum', options.bounds?.minimumUnits],
            ['profile_method_maximum', options.bounds?.maximumUnits],
        ]) {
            if (units !== null && units !== undefined)
                pills.push({
                    text: t(key, { amount: formatFiatUnits(units, 0, options.currency, options.locale) }),
                    tone: key === 'profile_method_minimum' ? 'success-subtle' : 'warning',
                });
        }
    }
    return pills;
}
function formatWholeFiat(units, decimals, currency, locale) {
    const scale = 10n ** BigInt(decimals);
    const rounded = (BigInt(units) + scale / 2n) / scale;
    return formatFiatUnits(rounded.toString(), 0, currency, locale);
}
